export default __webpack_public_path__ + "static/logo-df2fdbf9ab702fa98ee2c8630c1d5930.png";